import React, { useMemo } from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Divider,
  DialogTitle,
} from '@mui/material';
import {
  Close as CloseIcon,
  MenuBook as MenuBookIcon,
  Quiz as QuizIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Button from '../UIKit/Button';
import TestCard from './TestCard';

const LessonCompletionModal = ({
  open,
  onClose,
  lesson,
  tests = [],
  userProgress,
  onRepeatLesson,
  onStartTest,
  onViewTest,
  hasSpecialAccess = false,
}) => {
  const { t } = useTranslation(['courses', 'common']);

  // Мемоизируем тесты с индексами для оптимизации
  const testsWithIndexes = useMemo(() => {
    return tests.map((test, index) => ({
      ...test,
      index,
    }));
  }, [tests]);

  if (!lesson) return null;

  const renderContent = () => {
    return (
      <>
        {/* Repeat Lesson Button */}
        <Button
          variant="outlined"
          fullWidth
          onClick={onRepeatLesson}
          sx={{ mb: 3, py: 1.5 }}
          startIcon={<MenuBookIcon />}
        >
          {t('courses:courseDetail.lessonCompletion.repeatLesson')}
        </Button>

        {/* Tests Section */}
        {tests && tests.length > 0 && (
          <>
            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, textTransform: 'capitalize' }}>
              <QuizIcon /> {t('courses:courseDetail.stats.tests')} ({tests.length})
            </Typography>

            {/* Tests List */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {testsWithIndexes.map((test) => (
                <TestCard
                  key={test._id || test.index}
                  test={test}
                  userProgress={userProgress}
                  onStartTest={onStartTest}
                  onViewTest={onViewTest}
                  hasSpecialAccess={hasSpecialAccess}
                  variant="list"
                />
              ))}
            </Box>
          </>
        )}
      </>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: 3,
            p: 2,
          }
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end', p: 0 }}>
        <IconButton
          aria-label={t('common:actions.close')}
          onClick={onClose}
          sx={{
            color: 'grey.500',
          }}
          >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 4 }}>
        {renderContent()}
      </DialogContent>
    </Dialog>
  );
};

export default LessonCompletionModal;
